import { render } from "./HotTakePage.vue?vue&type=template&id=71826145&scoped=true"
import script from "./HotTakePage.vue?vue&type=script&lang=js"
export * from "./HotTakePage.vue?vue&type=script&lang=js"

import "./HotTakePage.vue?vue&type=style&index=0&id=71826145&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71826145"]])

export default __exports__